import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  Text,
  VStack,
} from "@chakra-ui/react";

interface ModalPopUpProps {
  show: boolean;
  title: string;
  handleOnClose: () => void;
  handleAction: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  confirmButtonText: string;
  cancelButtonText?: string;
  size?: ModalProps["size"];
  children: JSX.Element | JSX.Element[];
}

export const ActionModal = ({
  show,
  title,
  handleOnClose,
  handleAction,
  confirmButtonText,
  cancelButtonText,
  size,
  children,
}: ModalPopUpProps) => {
  return (
    <Modal
      size={size}
      isOpen={show}
      onClose={handleOnClose}
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader bg="gray.700" color="#fff" borderTopRadius={"4px"}>
          {title}
        </ModalHeader>
        <ModalCloseButton color="#fff" />
        <ModalBody mt={6}>{children}</ModalBody>

        <ModalFooter>
          {Boolean(cancelButtonText) && (
            <Button variant="secondary" mr={3} onClick={handleOnClose}>
              {cancelButtonText}
            </Button>
          )}

          {Boolean(confirmButtonText) && (
            <Button variant="primary" onClick={handleAction}>
              {confirmButtonText}
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

interface ModalPopUpContent {
  show: boolean;
  title: string;
  content: JSX.Element;
  handleOnClose: () => void;
  size?: ModalProps["size"];
}

export const InfoModal = ({
  show,
  title,
  content,
  handleOnClose,
  size = "lg",
}: ModalPopUpContent) => {
  return (
    <Modal
      size={size}
      isOpen={show}
      onClose={handleOnClose}
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader bg="gray.700" color="#fff" borderTopRadius={"4px"}>
          {title}
        </ModalHeader>
        <ModalCloseButton color="#fff" />
        <ModalBody mt={6}>
          <Text>{content}</Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" mr={3} onClick={handleOnClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const ModalText = ({ text }: { text?: string }) => {
  const resovledText = (text || "")
    .replaceAll("\\n", "\n")
    .split("\n")
    .filter(Boolean);

  return (
    <VStack spacing={"2px"} alignItems="baseline">
      {resovledText.map((line, index) => (
        <Text key={index}>{line}</Text>
      ))}
    </VStack>
  );
};

export const ModalDivider = () => <Divider my={4} />;
